import React, { useState, useEffect, useRef } from "react";
import "../../App.css";

// About GEOTECH Geospatial content component

function AboutGeospatial() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [videoError, setVideoError] = useState(false);
  const statsRef = useRef(null);
  const [statsVisible, setStatsVisible] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);
    const onError = () => {
      console.error('Video failed to load');
      setVideoError(true);
    };
    const onLoadedData = () => {
      console.log('Video loaded successfully');
      setVideoError(false);
    };

    video.addEventListener('play', onPlay);
    video.addEventListener('pause', onPause);
    video.addEventListener('error', onError);
    video.addEventListener('loadeddata', onLoadedData);

    return () => {
      video.removeEventListener('play', onPlay);
      video.removeEventListener('pause', onPause);
      video.removeEventListener('error', onError);
      video.removeEventListener('loadeddata', onLoadedData);
    };
  }, []);

  const togglePlay = () => {
    const video = videoRef.current;
    if (!video || videoError) return;

    try {
      if (video.paused) {
        video.play().catch(e => console.error('Play failed:', e));
      } else {
        video.pause();
      }
    } catch (error) {
      console.error('Video control error:', error);
    }
  };

  // Intersection Observer for stats section
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStatsVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    if (statsRef.current) obs.observe(statsRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <>
      <div className="about_bg">
        <section className="about-section" id="about-geospatial">
          <div className="about-section__container">
            {/* Video on the left side 
            <div className="about-section__video-wrapper">
              <div className="about-section__video-frame" onClick={togglePlay}>
                <video 
                  ref={videoRef}
                  className="about-section__video"
                  poster={`${process.env.PUBLIC_URL}/about_bg.jpg`}
                  controls={isPlaying}
                >
                  <source src={`/geotech-corporate-video.mp4`} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                
                <div className={`video-overlay ${isPlaying ? 'hidden' : ''}`}>
                  <svg 
                    className="video-toggle-icon" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="white" opacity="0.9"/>
                    <path 
                      d="M10 8L16 12L10 16V8Z" 
                      fill="#206AEC"
                    />
                  </svg>
                </div>
              </div>
            </div>*/}
            
            {/* Content on the right side */}
            <div className="about-section__content">
              <h2 className="about-section__title">About GEOTECH</h2>
              <p>We <strong>GEOTECH</strong> established in 2012 by seasoned professionals, is headquartered in the heart of Chennai. The company is dedicated to empowering users in the fields of GIS, IT, Agriculture, Health, Environment, Education & Research. With a significant presence in South India, Geotech has played a crucial role in setting up GIS/Remote Sensing laboratories and providing IT solutions to various Central and State Government departments, as well as private and research institutions. Further expanding its global reach, Geotech has successfully operated an overseas office in Singapore since 2022.</p>
            </div>
          </div>
        </section>

        <section className="stats-section" ref={statsRef}>
          <div className="stats-container">
            <h1 className="stats-header">Why Choose Us</h1>
            <div className="stats-row">
              {[
                { id: 'years', label: 'Years Experience', value: 25 },
                { id: 'clients', label: 'Happy Clients', value: 150 },
                { id: 'projects', label: 'Projects Completed', value: 150 },
                { id: 'team', label: 'Expert Team', value: 100 }
              ].map(({ id, label, value }) => (
                <div
                  key={id}
                  className={`stat-card ${statsVisible ? 'animate' : ''}`}
                >
                  <div className="stat-number">{value}+</div>
                  <div className="stat-label">{label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AboutGeospatial;